import React from 'react';
import { Field, ErrorMessageInstant, Label } from '../FormikCustom';
import ExpirationDate from '../ExpirationDate/ExpirationDate';

export default function CardAccountView({values}) {
    return (
        <section>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="CardBrand">Credit Card Brand:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field
                            type="text"
                            name="CardBrand"
                            maxLength="16"
                            disabled={true}
                            value={values.CardBrand || ''}
                            className="form-control"
                        />
                        <ErrorMessageInstant name="CardBrand" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label"></div>
                    <div className="col-sm-7 col-form-control">
                        <img src={values.CardImage} alt="CardImage" />
                        <ErrorMessageInstant name="CardBrand" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="CreditCardNumber">Credit Card Number:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field
                            type="text"
                            name="CreditCardNumber"
                            disabled={true}
                            maxLength="16"
                            value={values.CreditCardNumber || ''}
                            className="form-control"
                        />
                        <ErrorMessageInstant name="CreditCardNumber" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <div className="form-group row">
                    <div className="col-sm-3 col-lg-2 col-form-label">
                        <Label htmlFor="BillingZip">Billing Zip:</Label>
                    </div>
                    <div className="col-sm-7 col-form-control">
                        <Field
                            type="text"
                            name="BillingZip"
                            maxLength="3"
                            disabled={true}
                            value={values.BillingZip || ''}
                            className="form-control"
                        />
                        <ErrorMessageInstant name="BillingZip" />
                    </div>
                </div>
            </div>
            <div className="form-group">
                <ExpirationDate
                    disabled={true}
                    name="CreditCardExpirationDate"
                    size={2}
                    value={values.CardExpDate}
                  
                />
            </div>
        </section>
    );
}
